import { render, staticRenderFns } from "./TableInsurances.vue?vue&type=template&id=2ac42cfe&"
import script from "./TableInsurances.vue?vue&type=script&lang=js&"
export * from "./TableInsurances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports